import { Coach } from '../../../../types/coaches'
import {
	OrgSettingUsersFilterKeys,
	OrgSettingUsersStateFilters,
} from '../../../../types/orgSettings'

export interface OrgSettingsUsersState {
	list: Array<Coach>
	searchValue: string
	filters: OrgSettingUsersStateFilters
}

export enum ORG_SETTINGS_USERS_ACTIONS_TYPES {
	GET = 'ORG_SETTINGS_GET_USERS_LIST',
	SET_SEARCH_VALUE = 'ORG_SETTINGS_USERS_SET_SEARCH_VALUE',
	SET_FILTER_VALUE = 'ORG_SETTINGS_USERS_SET_FILTER_VALUE',
	SET_DATE_STARTED_FILTER_VALUE = 'ORG_SETTINGS_USERS_SET_DATE_STARTED_FILTER_VALUE',
	UNSET_FILTER_VALUE = 'ORG_SETTINGS_USERS_UNSET_FILTER_VALUE',
	RESET = 'ORG_SETTING_USERS_RESET',
}

export interface OrgSettingsGetUsersListAction {
	type: ORG_SETTINGS_USERS_ACTIONS_TYPES.GET
	payload: Array<Coach>
}

export interface OrgSettingsSetUsersSearchValueAction {
	type: ORG_SETTINGS_USERS_ACTIONS_TYPES.SET_SEARCH_VALUE
	payload: string
}

export interface OrgSettingsSetUsersFilterValue {
	type: ORG_SETTINGS_USERS_ACTIONS_TYPES.SET_FILTER_VALUE
	payload: {
		key: OrgSettingUsersFilterKeys
		value: string
	}
}

export interface OrgSettingsUnSetUsersFilterValue {
	type: ORG_SETTINGS_USERS_ACTIONS_TYPES.UNSET_FILTER_VALUE
	payload: {
		key: OrgSettingUsersFilterKeys
		value: string
	}
}

export interface OrgSettingsSetUsersDateStartedFilterValue {
	type: ORG_SETTINGS_USERS_ACTIONS_TYPES.SET_DATE_STARTED_FILTER_VALUE
	payload: number
}

export interface OrgSettingsUsersReset {
	type: ORG_SETTINGS_USERS_ACTIONS_TYPES.RESET
}

export type OrgSettingsCoachesActions =
	| OrgSettingsGetUsersListAction
	| OrgSettingsSetUsersSearchValueAction
	| OrgSettingsSetUsersFilterValue
	| OrgSettingsUnSetUsersFilterValue
	| OrgSettingsUsersReset
	| OrgSettingsSetUsersDateStartedFilterValue
